import React from "react";
// redux
import { useSelector } from "react-redux";
//react components for routing our app without refresh
// import { useParams } from "react-router";
import { useParams, Link } from "react-router-dom";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
// other
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-kit-react/views/components.js";
import { formatDateTime } from "utils.js";

const useStyles = makeStyles(styles);

export default function FoundHistoryDetailPage() {
  const classes = useStyles();
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );

  const { id } = useParams();
  const hist = useSelector(
    (state) =>
      state.foundHistory.filter(
        (foundHistoryItem) => foundHistoryItem.id === id
      )[0]
  );

  return (
    <div>
      <Header
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 200,
          color: "white",
        }}
      />
      <Parallax small filter image={require("assets/img/bg4.jpg")}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h1 className={classes.title}>History</h1>
                <h3 className={classes.subtitle}>
                  The history of all transactions in the Lost and Found
                  Department
                </h3>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={classNames(classes.main, classes.mainRaised)}>
        <GridContainer className={classes.container}>
          <GridItem xs={12} md={6} className="my-5">
            <img
              src={hist?.imageId}
              alt="historyitem"
              width="100%"
              className={imageClasses}
            />
          </GridItem>
          <GridItem xs={12} md={6} className="my-5">
            <Table className="minWidth: 650" aria-label="simple table">
              <TableBody>
                <TableRow>
                  <TableCell align="right">Item Name</TableCell>
                  <TableCell align="left">{hist?.itemName}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Description</TableCell>
                  <TableCell align="left">{hist?.description}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Posted By</TableCell>
                  <TableCell align="left">
                    {" "}
                    <Link to={"/users/" + hist?.username}>
                      {hist?.username}
                    </Link>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Returned To</TableCell>
                  <TableCell align="left">
                    {" "}
                    <Link to={"/users/" + hist?.resolverUsername}>
                      {hist?.resolverUsername}
                    </Link>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Found Location</TableCell>
                  <TableCell align="left">{hist?.location}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Found on</TableCell>
                  <TableCell align="left">
                    {formatDateTime(hist?.foundTimestamp)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Posted on</TableCell>
                  <TableCell align="left">
                    {formatDateTime(hist?.createdAt)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Updated on</TableCell>
                  <TableCell align="left">
                    {formatDateTime(hist?.updatedAt)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">Returned on</TableCell>
                  <TableCell align="left">
                    {formatDateTime(hist?.resolvedTimestamp)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>

            <br />
          </GridItem>
        </GridContainer>
      </div>
      <Footer />
    </div>
  );
}
